import React from 'react';
import styled from '@emotion/styled';

import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';

const CardWrapper = styled.div`
  flex: 1;
  border-bottom: 2px solid #e1e1e1;
  border-right: 2px solid #e1e1e1;
  max-width: 100%;
  padding: 10px;
  margin-botton: 20px;
  background-color: #fff;
`;

const Image = styled(AnimatedLoader)`
  width: 100%;
  height: 390px;
  display: inline-block;
`;

const DetailsWrapper = styled.div``;

const Line = styled(AnimatedLoader)<ShimmerProps>`
  height: ${(props) => props.height}px;
  margin: 8px 0;
  width: 100%;
`;

const Title = styled(AnimatedLoader)`
  height: 44px;
  margin: 12px 0;
  width: 100%;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  min-height: 300px;
`;

interface ShimmerProps {
  height: number;
}

const SelectorWrapper = styled(AnimatedLoader)`
  height: 100px;
  width: 100%;
`;

export const ProductLoader = () => (
  <>
    <Image className="client" />
    <Wrapper>
      <CardWrapper>
        <DetailsWrapper>
          <Title className="client" />
          <Line
            height={22}
            className="client"
          />
          <Line
            height={18}
            className="client"
          />
          <Line
            height={14}
            className="client"
          />
        </DetailsWrapper>
      </CardWrapper>
      <CardWrapper>
        <SelectorWrapper className="client" />
      </CardWrapper>
    </Wrapper>
  </>
);
